import { TransactionTimerPickUpPendingDurationMetricChart } from '@frontend/chart/components';
import { FormattedMessage } from 'react-intl';

import { Last60DaysPudoTimerDurationMetricChartCard } from '../last-60-days-pudo-timer-duration-metric-chart-card.component';

export interface Last60DaysPudoTransactionPickUpTimeMetricChartProps {
    accountId: string;
}

export const Last60DaysPudoTransactionPickUpTimeMetricChart = ({ accountId }: Last60DaysPudoTransactionPickUpTimeMetricChartProps) => (
    <Last60DaysPudoTimerDurationMetricChartCard
        accountId={accountId}
        title={
            <FormattedMessage
                id='platform.statistics.pudo.last-60-days-pudo-transaction-pick-up-time-metric-chart.title'
                description='Title of the PuDo dashboard card showing average pick-up time compared to last month'
                defaultMessage='Pick-up time'
            />
        }
        Chart={TransactionTimerPickUpPendingDurationMetricChart}
    />
);
